<template>
  <a @click="routerPage(post)" class="content-card-post">
    <div
      class="content-card-post--image"
      :style="{ background: `url(${getUrlImage})` }"
    ></div>
    <div class="content-card-post--text">
      <h2>{{ post.title_description }}</h2>
      <p>{{ post.text_description }}</p>
    </div>
  </a>
</template>

<script>
export default {
  props: ["post"],
  computed: {
    getUrlImage() {
      if (this.post.post_picture) {
        return `data:image/jpg;base64,${this.post.post_picture}`;
      }

      return this.post.picture_file_path;
    },
  },
  methods: {
    routerPage(post) {
      this.$router.push({
        name: "RegisterPosts",
        params: {
          id_category: post.id_category,
          id_post: post.id_post,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.content-card-post {
  display: block;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  transition: 500ms;
  &:hover,
  &:focus {
    cursor: pointer;
    opacity: 0.8;
  }
  &--image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat !important;
    background-position: center !important;
    border-radius: 10px 10px 0px 0px;
  }
  &--text {
    padding: 15px;
    text-align: left;
    h2 {
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--black);
      margin-bottom: 10px;
      @media (min-width: 577px) {
        height: 40px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    p {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      margin-bottom: 0;
      @media (min-width: 577px) {
        height: 65px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
}
</style>
